"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _CollapsiblePanel = require("./CollapsiblePanel");
Object.keys(_CollapsiblePanel).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _CollapsiblePanel[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _CollapsiblePanel[key];
    }
  });
});